import React, { useState } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = ({ isScrolled }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  const navItems = [
    { label: 'Home', id: 'hero' },
    { label: 'About', id: 'about' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'Features', id: 'features' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'FAQ', id: 'faq' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <img
              src="https://static.wixstatic.com/media/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png/v1/fill/w_212,h_93,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/5924bc_1d4a840f9cb44afcb7ee8f647411679d~mv2.png"
              alt="Equi-Go Logo"
              className="h-12 w-auto transition-all duration-300 hover:scale-105"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-sm font-medium text-gray-700 hover:text-[#2d5f3f] transition-colors duration-200 relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2d5f3f] transition-all duration-300 group-hover:w-full"></span>
              </button>
            ))}
          </nav>

          {/* Contact Info & CTA */}
          <div className="hidden lg:flex items-center space-x-4">
            <a
              href="tel:07788754165"
              className="flex items-center space-x-2 text-sm text-gray-600 hover:text-[#2d5f3f] transition-colors duration-200"
            >
              <Phone className="w-4 h-4" />
              <span>07788754165</span>
            </a>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#2d5f3f] hover:bg-[#1e4029] text-white transition-all duration-300 hover:scale-105"
            >
              Enquire Now
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-[#2d5f3f] transition-colors duration-200"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 border-t border-gray-200 animate-fadeIn">
            <nav className="flex flex-col space-y-3">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className="text-left px-4 py-2 text-gray-700 hover:text-[#2d5f3f] hover:bg-gray-50 rounded-lg transition-all duration-200"
                >
                  {item.label}
                </button>
              ))}
              <div className="px-4 pt-3 space-y-2 border-t border-gray-200">
                <a
                  href="tel:07788754165"
                  className="flex items-center space-x-2 text-sm text-gray-600 hover:text-[#2d5f3f] transition-colors duration-200"
                >
                  <Phone className="w-4 h-4" />
                  <span>07788754165</span>
                </a>
                <Button
                  onClick={() => scrollToSection('contact')}
                  className="w-full bg-[#2d5f3f] hover:bg-[#1e4029] text-white transition-colors duration-300"
                >
                  Enquire Now
                </Button>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;